import { Container, FieldText, ValueText } from './QuickInformationDisplay.styles';

const QuickInformationDisplay = ({
    fieldName,
    value,
    boldField = false,
    boldValue = false
}: {
    fieldName: string
    value: string
    boldField?: boolean
    boldValue?: boolean
}) => {
    return (
        <Container>
            <FieldText $bold={boldField}>
                {fieldName}:
                <ValueText $bold={boldValue}>
                    {value}
                </ValueText>
            </FieldText>
        </Container>
    )
}

export default QuickInformationDisplay
